// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__12xof","list":"BalanceDue_list__3zCsd","listRow":"BalanceDue_listRow__3atvt","total":"BalanceDue_total__22b4T"};